import { useCallback, useContext, useEffect } from 'react'
import type { DependencyList } from 'react'
import { EventEmitterRCContext } from '@tools/eventEmitterContext/EventEmitterRC'
import type { BaseEvents } from '@tools/EventEmitter'

function useEmit<Events extends BaseEvents>() {
    const em = useContext(EventEmitterRCContext)
    return useCallback(<E extends keyof Events>(type: E, ...args: Events[E]) =>
        (async () => await em.emit(type, ...args))()
    ,[em])
}

export function useEventEmitter<Events extends BaseEvents>() {
    const emit = useEmit()
    return {
        useListener: <E extends keyof Events>(
            type: E,
            listener: (...args: Events[E]) => void,
            deps: DependencyList = [],
        ) => {
            const em = useContext(EventEmitterRCContext)
            useEffect(() => {
                em.add(type, listener)
                return () => {
                    em.remove(type, listener)
                }
                // eslint-disable-next-line react-hooks/exhaustive-deps
            }, [listener, type, ...deps])
        },
        emit,
    }
}
